import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

/**
 * Vuex modules
 */
import UserModule from "./modules/user.module";
import AppModule from "./modules/app.modules";
import BlogModule from "./modules/blog.modules";
import ConsultationModule from "./modules/consultation_type.module";
import SettingsModule from "./modules/settings.module";

Vue.use(Vuex);

const APP_VERSION = "1.2";

export default new Vuex.Store({
  modules: {
    user: UserModule,
    app: AppModule,
    blog: BlogModule,
    consultation_type: ConsultationModule,
    settings: SettingsModule,
  },
  plugins: [
    createPersistedState({
      key: "start_app",
      paths: ["app", "user", "blog", "settings"],
      storage: {
        getItem: (key) => {
          const data = JSON.parse(localStorage.getItem(key) || "{}");

          // Якщо версія не збігається — видаляємо старий стан
          if (data.version !== APP_VERSION) {
            localStorage.removeItem(key);
            return null; // повертаємо null для чистого стану
          }

          return JSON.stringify(data);
        },
        setItem: (key, data) => {
          const payload = {
            ...JSON.parse(data),
            version: APP_VERSION, // додаємо поточну версію
          };
          localStorage.setItem(key, JSON.stringify(payload));
        },
        removeItem: (key) => localStorage.removeItem(key),
      },
    }),
  ],
});
